<template>
  <div v-if="load">
    <scale-loader/>
  </div>
  <div v-else-if="profile == null">
    <div class="wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
              <h2 class="title text-danger">
                SimCardProfile: {{cur_id}} not found
              </h2>
              <router-link :to="{path:'/simcard_profile_list'}">
                To List SimCardProfile
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <tabs parent="simcard_profile" v-else>
    <tab id="profile" :name="translate('simcard_profile.section.profile')" :href="url+'/profile'" >
      <Profile :id="cur_id" :profile="profile" ref="profile"/>
    </tab>

    <tab id="tariff" :name="translate('simcard_profile.section.tariff')" :href="url+'/tariff'">
      <Tariff :sim_id="cur_id" />
    </tab>

    <tab id="actions" v-if="this.$store.getters.getPermissions?.controlSimcardProfile === true" :name="translate('simcard_profile.section.actions')" :href="url+'/actions'">
      <Actions :sim_id="cur_id" :profile="profile"/>
    </tab>

  </tabs>
</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Profile from './SimCardProfile/Profile.vue'
import Tariff from './SimCardProfile/Tariff.vue'
import Actions from './SimCardProfile/Actions.vue'

export default {
  name: 'SimCardProfile',
  components: {
    Profile,
    Tariff,
    Actions,
    Tab,
    Tabs,
  },
  data () {
    return {
      pred_id: false,
      section: 'profile',
      interval: null,
      simcard: {},
      change: false
    }
  },

  beforeRouteLeave(to, from, next) {
    this.ProveSaveOnLeave(next)
  },

  beforeRouteUpdate(to, from, next) {
    this.ProveSaveOnLeave(next)
  },

  computed: {
    url () { return '/simcard_profile/' + this.$route.params.simcard_profile_id },
    cur_id () { return this.$route.params.simcard_profile_id },
    profile () { return this.simcard.profile },
    load () {
      if (this.simcard) {
        return this.simcard.load === undefined || this.simcard.load
      }
      return true
    }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'simcard_profile_section') {
        this.set_simcard()
      } else {
        clearInterval(this.interval)
      }
    },
    $route () {
      if (this.$route.params.simcard_profile_section === 'profile') {
        this.set_simcard()
      }
    }
  },

  activated(){
    this.set_simcard()

    this.interval = setInterval(() => {
      this.set_simcard()
    }, this.$store.getters.getSimcardProfileProfileUpdate)
  },

  deactivated () {
    clearInterval(this.interval)
  },
  methods: {
    OnChange (value) {
      this.change = value
    },
    ProveSaveOnLeave (next) {
      next()
    },

    set_simcard () {
      if (this.cur_id) {
        this.$store.dispatch('updateSimcardProfileProfile', +this.cur_id)
        this.simcard = this.$store.getters.getSimcardProfileById(+this.cur_id)
      }
    }
  }
}

</script>
